import { CommonModule } from "@angular/common";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NguiAutoCompleteModule } from "@ngui/auto-complete";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { VersionSettings } from "../pb-screen/static/client/versionSettings";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { GridModule, SharedModule } from "@progress/kendo-angular-grid";
import { LoadingModule } from "ngx-loading";
import { UserAuthorizationsViewComponent } from "./components/user-authorization-view.component";
import { UsersTableComponent } from "./containers/users-table/users-table.component";
import { UpdateScreenAuthorizationComponent } from "./modals/update-screen-authorization/update-screen-authorization-modal.component";
import { UserAuthorizationActions } from "./user-authorization.actions";
import { UsersAuthorizationService } from "./user-authorization.service";

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "resources/", `.json?v=${VersionSettings.versionNumber}`);
}

@NgModule({
    declarations: [
        UserAuthorizationsViewComponent,
       UsersTableComponent,
       UpdateScreenAuthorizationComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                deps: [HttpClient],
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
            },
        }),
        NguiAutoCompleteModule,
        LoadingModule,
        BrowserAnimationsModule,
        GridModule,
        DropDownsModule
    ],
    exports: [
        UserAuthorizationsViewComponent,
        UsersTableComponent,
        UpdateScreenAuthorizationComponent
    ],
    providers: [
        UsersAuthorizationService,
        UserAuthorizationActions

    ],
})

export class UserAuthorizationModule {

}
